import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedNavbarService {
  private readonly http = inject(HttpClient);

  showNav: boolean;

  constructor() {
    this.showNav = true;
  }

  show(): void {
    this.showNav = true;
  }

  hide(): void {
    this.showNav = false;
  }

  getVersion(): Observable<string> {
    const uri = `${environment.api}/maintenance/version`;
    return this.http.get<string>(uri);
  }
}
